import styled from 'styled-components';

export const ContainerLogin = styled.div`
  background-color: #FFFFFF;
  width: -webkit-fill-available;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: center;
  max-height: 100vh;
  overflow-y:auto;
`;

export const DivVertical = styled.div`
  height: auto;
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: -webkit-fill-available;
  max-width: 450px;
  align-content: center;
  justify-content: center;
  align-items: center;
  padding: 0px 16px;
  box-sizing: border-box;
  height: 100vh;
`;

export const Title = styled.h1`
  width: -webkit-fill-available;
  font-family: 'Montserrat', sans-serif;
  font-weight: 800;
  font-size: 44px;
  color: #003049;
  text-align: center;
  @media only screen and (min-width:0px) and (max-width:1100px){
    font-size: 28px;
  }
`;


export const Form = styled.form`
  background-color: #FFFFFF ;
  width: -webkit-fill-available;
  max-width:350px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  // border: solid 1px red;
  height: auto;
  box-shadow: rgba(136, 165, 191, 0.48) 6px 2px 16px 0px, rgba(255, 255, 255, 0.8) -6px -2px 16px 0px;
  border-radius: 8px;
  padding: 8px;
`;

export const TextInput = styled.span`
  width: -webkit-fill-available;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #07082c;
`;

export const TextError = styled.p`
  width: -webkit-fill-available;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #d00e58;
  text-align: center;
`;

export const Input = styled.input`
  width: -webkit-fill-available;
  padding:5px;
  border:solid 2px #8b9ea8;
  outline: none;
  background:#FFFFFF;
  border-radius:8px;
  height:40px;
  min-height:40px;
  font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    font-size: 14px;
    color: #003049;
  &::placeholder{
    font-family: 'Montserrat', sans-serif;
    font-weight: 400;
    font-size: 14px;
    color: #07082c;
  }
  &:focus{
    border:solid 2px #003049;
  }
`;
export const PasswordInput = styled.input`
  width: -webkit-fill-available;
  padding:5px;
  border:solid 2px #8b9ea8;
  outline: none;
  background:#FFFFFF;
  border-radius:8px;
  height:40px;
  min-height:40px;
  letter-spacing: 5px;
  font-size: 20px;
  -webkit-text-security: disc;
  text-security: disc;
  &::placeholder{
      white-space: nowrap;
      font-family: 'Montserrat', sans-serif;
        font-weight: 400;
        font-size: 14px;
        letter-spacing: 0px;
      color: #07082c;

    }
  &:focus{
      border:solid 2px #003049;
  }
`;

export const InputContainer = styled.div`
  height:auto;
  width:-webkit-fill-available;
  display: flex;
  flex-direction:column;
  gap:5px;
  align-items: flex-start;
`;

export const LoginButton = styled.button`
  width: 100%;
  padding:5px;
  border:solid 2px #003049;
  outline: none;
  background:#FFFFFF;
  border-radius:8px;
  transition: all 0.5s;
  cursor:pointer;
  padding:8px;
  display:flex;
  flex-direction:column;
  align-items:center;
  min-height:39px;
  justify-content: center;
  font-family: 'Montserrat', sans-serif;
    font-weight: 600;
    font-size: 16px;
    color: #003049;
  &:hover { 
    background:#8b9ea8;
    color:#FFFFFF;
  }
  &:active {
    background:#8b9ea8;
    color:#FFFFFF;
    transition: all 0.1s;
  }
`;

